import React from 'react';
import PostsConfig from './components/postsConfig';
import ManageTypes from './components/ManageTypes';
import LimiterList from './components/LimiterList';
import { Box } from '@mui/material';

export const CompanyConfiguration = () =>{
    return (
        <Box sx={{height: '100%',backgroundColor:'white',padding:'10px'}}>
            <ManageTypes />
            <LimiterList />
            <PostsConfig />
        </Box>
    );
}
